import Layout from '@/components/layout/Layout.vue'
import { getCorporations } from '@/api/open'
import { getMediaProjectCloseTasks, tryAgainMediaProjectCloseTasks, deleteAdvertiserProjects } from '@/api/media-project-close-task'
import { getMedias } from '@/api/constant'
import SyncForm from '@/views/sys/video/sync/Sync.vue'
import UploadForm from '@/views/sys/media-project-close-task/upload/Upload.vue'
import moment from 'moment'

export default {
    name: 'media_project_close_tasks',
    components: {
        Layout,
        SyncForm,
        UploadForm,
    },
    data() {
        return {
            data: [],
            loading: false,
            medias: [],
            columns: [
                { minWidth: 80, title: '任务ID', fixed: 'left', field: 'id', formatter: 'empty' },
                { minWidth: 120, title: '日期', fixed: 'left', field: 'day', formatter: 'empty' },
                { minWidth: 80, title: '媒体', formatter: item => {
                    return this.$helper.getItemName(this.medias, item.row.media) || '-'
                }},
                { minWidth: 80, title: '任务类型', formatter: item => {
                    return this.$helper.getItemName(this.taskTypes, item.row.type) || '-'
                }},
                { minWidth: 120, title: '操作类型', formatter: item => {
                    return this.$helper.getItemName(this.opeTypes, item.row.ope_type) || '-'
                }},
                { minWidth: 180, title: '广告主ID', field: 'advertiser_id', formatter: 'empty' },
                { minWidth: 220, title: '广告主名称', field: 'advertiser_name', formatter: 'empty' },
                { minWidth: 180, title: '项目/计划ID', field: 'out_id', formatter: 'empty' },
                { minWidth: 220, title: '素材ID', field: 'material_id', formatter: 'empty' },
                { minWidth: 80, title: '付费类型', formatter: item => {
                    return this.$helper.getItemName(this.payTypes, item.row.pay_type) || '-'
                }},
                { minWidth: 80, title: '操作次数', field: 'num', formatter: 'empty' },
                { minWidth: 90, title: '任务状态', field: 'status', slots: { default: 'taskStatus' } },
                { minWidth: 80, title: '执行结果', field: 'result', slots: { default: 'result' } },
                { minWidth: 180, title: '创建时间', field: 'created_at', formatter: 'empty' },
                { minWidth: 180, title: '更新时间', field: 'updated_at', formatter: 'empty' },
                { minWidth: 160, title: '操作', fixed: 'right', slots: { default: 'actions' } }
            ],
            model: {},
            // 日期筛选默认取今天，避免首屏加载全量数据
            queryParam: {
                day: moment().format('YYYY-MM-DD'),
            },
            channels: [],
            platforms: [],
            workers: [],
            tableGrid: this.getTableGrid(),
            corporations: [],
            showUploadForm: false,
            taskStatus: [{id:1, name:'未执行'},{id:2, name:'已完成'},{id:3, name:'执行失败'}],
            taskTypes: [{id:1, name:'系统'},{id:2, name:'手动'}],
            opeTypes: [{id:1, name:'关停项目/计划'},{id:2, name:'删除项目'},{id:3, name:'删除违规素材'},{id:4, name:'启用项目/计划'},{id:5, name:'批量ROI出价'},{id:6, name:'批量预算'}],
            payTypes: [{id:1, name:'收费'},{id:2, name:'免费'}],
            result: {
                success: [],
                errors: []
            },
            defaultDate: moment(),
            master: false,
            deleteModalVisible: false,
            deleteLoading: false,
            deleteForm: {
                advertiser_ids: '',
                media: 2,
            },
        }
    },
    mounted() {
        this.tableGrid.columns = this.columns
        getCorporations().then(res=>{ this.corporations = res.data.list || {} })
        getMedias().then(res=>{ this.medias = res.data.list || {} })
        this.getData()
        console.log(this.$options.filters)
    },
    methods: {
        getTableGrid() {
            let grid = this.$helper.tableGrid('media_project_close_tasks')
            grid.size = 'medium'
            grid.border = 'inner'
            return grid
        },
        edit(record) {
            this.model = Object.assign({}, record)
        },
        getData() {
            this.tableGrid.loading = true
            const json = Object.assign({}, this.queryParam, {
                page: this.tableGrid.pagerConfig.currentPage,
                page_size: this.tableGrid.pagerConfig.pageSize
            })
            getMediaProjectCloseTasks(json).then(res => {
                this.tableGrid.pagerConfig.total = res.data.total
                this.tableGrid.loading = false
                this.tableGrid.data = res.data.list
                this.data = res.data.list || []
                this.master = res.data.master
            }).catch(() => {
                this.loading = false
            })
        },
        refresh() {
            this.getData()
        },
        search() {
            this.tableGrid.pagerConfig.currentPage = 1
            this.getData()
        },
        resetSearch() {
            // 重置后仍保留“默认今天”的筛选口径
            this.queryParam = {
                day: moment().format('YYYY-MM-DD'),
            }
            this.getData()
        },
        handlePageChange(pager) {
            this.tableGrid.pagerConfig.currentPage = pager.currentPage
            this.tableGrid.pagerConfig.pageSize = pager.pageSize
            this.getData()
        },
        handleSortChange(data) {
            this.queryParam.sort_field = data.order ? data.field : null
            this.queryParam.sort_type = data.order
            this.getData()
        },
        accessTo(route) {
            return this.$helper.accessTo('MediaProjectCloseTaskController', route)
        },
        upload() {
            this.showUploadForm = true
        },
        showResult(task) {
            this.result.success = task.success
            this.result.errors = task.errors
        },
        close() {
            this.result.success = []
            this.result.errors = []
        },
        tryAgain(row) {
            tryAgainMediaProjectCloseTasks({'id':row.id}).then(res => {
                this.$message.destroy()
                if (res && res.code === 0) {
                    this.$message.success('重试成功')
                    this.search()
                } else {
                    this.$message.error(res.message);
                }
            })
        },
        showDeleteModal() {
            this.deleteModalVisible = true
            this.deleteForm.advertiser_ids = ''
        },
        closeDeleteModal() {
            this.deleteModalVisible = false
            this.deleteForm.advertiser_ids = ''
        },
        handleDelete() {
            const advertiserIds = this.deleteForm.advertiser_ids.trim()
            if (!advertiserIds) {
                this.$message.warning('请输入广告主ID')
                return
            }
            
            this.deleteLoading = true
            const advertiserList = advertiserIds.split('\n').map(id => id.trim()).filter(id => id)
            
            deleteAdvertiserProjects({ 
                media: this.deleteForm.media,
                advertiser_ids: advertiserList 
            }).then(res => {
                this.$message.destroy()
                this.deleteLoading = false
                if (res && res.code === 0) {
                    this.$message.success('删除成功')
                    this.closeDeleteModal()
                    this.search()
                } else {
                    this.$message.error(res.message)
                }
            }).catch(() => {
                this.deleteLoading = false
            })
        }
    },
    filters: {
        statusColor(status) {
            switch (status) {
                case 1:
                    return 'orange'
                case 2:
                    return 'green'
                case 3:
                    return 'red'
                default:
                    return ''
            }
        }
    },
}
